// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"ef8f787b","9":"972d5e06","28":"46ca3f03","58":"4474dd32","247":"e84ba2c6","292":"a7d4f09c","521":"34bccc95","524":"c7c0a5c4","575":"b4247870","583":"d1097fbd","716":"6b7b3d9a","760":"3d783476","863":"913d2944","911":"7cbb0d78"}[chunkId] + ".chunk.js";
};